import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { debounce } from '@/lib/lodash'
import sliceText from '@/helpers/sliceText'
import { VTextArea } from '@/types/vuetify/VTextArea'
import getCountLetters from '@/helpers/getCountLetters'

@Component({
  inheritAttrs: false,
})
export default class STextArea extends Vue {
  @Ref('textarea')
  private readonly textareaRef!: VTextArea

  @Prop({ type: Boolean, default: false })
  private readonly hiddenCounter!: boolean

  @Prop({ type: Boolean, default: false })
  private readonly autoHideDetails!: boolean

  @Prop({ type: Number })
  private readonly maxlength?: number

  @Prop({ type: Number })
  private readonly counter?: number

  @Prop({ type: String })
  private readonly value?: string

  private get localListeners() {
    const $listeners = { ...this.$listeners }

    delete $listeners.input

    return $listeners
  }

  private validate(force?: boolean) {
    return this.textareaRef?.validate(force)
  }

  private onInput(value: string) {
    const initialValue = this.value || ''

    if (!this.maxlength) {
      this.$emit('input', value)
      return
    }

    if (getCountLetters(initialValue) > this.maxlength) {
      this.$emit('input', value)
      return
    }

    const slicedValue = sliceText({
      text: value,
      start: 0,
      end: this.maxlength,
    })

    this.textareaRef.lazyValue = slicedValue
    this.$nextTick(this.textareaRef.calculateInputHeight)

    if (slicedValue === this.value) {
      return
    }

    this.$emit('input', slicedValue)
  }

  private mounted() {
    const handleResize = debounce(() => {
      this.textareaRef?.calculateInputHeight()
    }, 50)

    const resizeObserver = new ResizeObserver(handleResize)

    resizeObserver.observe(this.$el)

    this.$once('hook:beforeDestroy', () => {
      handleResize.cancel()
      resizeObserver.disconnect()
    })
  }
}
